export default __webpack_public_path__ + "static/media/480_dummy2016-asia-restaurant01-mobile-de.1c6624d4.png";